import { useViewportSize } from '@mantine/hooks'
import { theme } from '@qr-front/ui'
import { pxStringToNumber } from '@qr-front/ui/utils'
import Image from 'next/image'

export const HelpImage = ({
	urlMobile,
	urlDesktop,
	alt,
}: {
	urlMobile: string
	urlDesktop: string
	alt: string
}) => {
	const { width } = useViewportSize()

	const isTablet = width >= pxStringToNumber(theme.screens.tablet)

	return (
		<div className="relative h-0 overflow-clip rounded-t-10 bg-generator-bg pb-[60%]">
			<Image
				src={isTablet ? urlDesktop : urlMobile}
				alt={alt}
				fill
				loading="eager"
			/>
		</div>
	)
}
